"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Skirt = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../../");
var useResizeObserver_1 = require("../useResizeObserver");
var Skirt_module_scss_1 = __importDefault(require("./Skirt.module.scss"));
var spacing = 24;
var maxHeight = 222;
var fallbackPercentage = 0.8;
var Skirt = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.titleBlockHasNavigation, titleBlockHasNavigation = _c === void 0 ? true : _c, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["children", "className", "variant", "titleBlockHasNavigation", "classNameOverride"]);
    var _d = (0, useResizeObserver_1.useResizeObserver)(function (entry) {
        if (entry.contentRect) {
            return deriveSkirtHeight(entry.contentRect, titleBlockHasNavigation);
        }
        return undefined;
    }), ref = _d[0], skirtHeight = _d[1];
    return (react_1["default"].createElement(__1.Container, __assign({ ref: ref, classNameOverride: (0, classnames_1["default"])(Skirt_module_scss_1["default"].container, className, classNameOverride) }, restProps),
        react_1["default"].createElement("div", { style: __assign({}, (skirtHeight && { height: "".concat(skirtHeight, "px") })), className: (0, classnames_1["default"])(Skirt_module_scss_1["default"].underlay, Skirt_module_scss_1["default"]["".concat(variant, "Variant")]) }),
        react_1["default"].createElement(__1.Content, { classNameOverride: Skirt_module_scss_1["default"].content }, children)));
};
exports.Skirt = Skirt;
exports.Skirt.displayName = "Skirt";
var deriveSkirtHeight = function (rect, titleBlockHasNavigation) {
    var height = rect.height, width = rect.width;
    var responsiveOffset = 0;
    if (width > 768) {
        responsiveOffset = 2.8125 * 16;
    }
    // This ensures the maximum height of the skirt is consistent between pages
    // where the title block has/doesn’t have navigation
    var derivedMaxHeight = titleBlockHasNavigation
        ? maxHeight
        : maxHeight + responsiveOffset;
    var maxHeightWithSpacing = derivedMaxHeight + spacing;
    return Math.max(spacing, height > maxHeightWithSpacing
        ? derivedMaxHeight
        : height * fallbackPercentage - spacing);
};
//# sourceMappingURL=Skirt.js.map